import { CustomSelectProps, SelectProps } from '../FormElements';
import './CustomSelect.css';
import Select from 'react-select';

function CustomSelect(props: CustomSelectProps){
    const handleChange = (selectedOption: SelectProps | null) => {
        props.onChange.data(prev => (
                {
                    ...prev, 
                    [props.changeSubject]: selectedOption?.value 
                }
            )
        );
        if (!props.onChange.buttonState)
            props.onChange.button(prev => (!prev));
    };

    return(
        <Select 
            inputId={ props.id }
            options={ props.options } 
            defaultValue={ props.defaultValue } 
            placeholder={ props.placeHolder }
            isDisabled={ props.isDisabled }
            onChange={ handleChange }
        />
    )
}

export default CustomSelect;